//
//
//

import { getToken, setToken, removeToken } from "@/store/getToken";
import promise from "@/axios/promise";
import { BASIC } from "@/config/constant";
export default {
  data() {
    return {
      code: this.$route.query.code,
      state: this.$route.query.state,
      wechatCode: "",
    };
  },
  methods: {
    //根据code获取用户的wechatcode
    getWechatCodeByCode() {
      debugger;
      promise({
        url: BASIC + "/wechat/userId/code",
        method: "get",
        params: { code: this.code, state: this.state },
      }).then((res) => {
        debugger;
        if (res.code == 0) {
          this.wechatCode = res.wechatCode;
          this.getTokenByWechatCode();
        }
      });
    },
    //根据wechatcode获取token
    getTokenByWechatCode() {
      //获取token
      promise({
        url: "/token/generateToken",
        method: "post",
        params: {
          username: "",
          password: "",
          wechatCode: this.wechatCode,
          state: this.state,
        },
      }).then((res) => {
        debugger;
        if (res.status == "S") {
          setToken(res.token);
          sessionStorage.setItem("username", res.username);
          this.toTaskCenter();
        } else {
          this.toLogin();
        }
      });
    },
    //跳转我的任务
    toTaskCenter() {
      this.$router.push({ path: "/wechat/taskCenter" });
    },
    //跳转到登录页
    toLogin() {
      this.$router.push({
        path: "/login",
        query: { url: "/wechat/taskCenter", wechatCode: this.wechatCode },
      });
    },
  },
  mounted() {
    this.getWechatCodeByCode();
  },
};



// WEBPACK FOOTER //
// ./src/view/wechat/taskCenterLoading.vue